import React from 'react';
import {
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';

import { InputDryRunResult } from '../../../types/admin';
import { formatValue } from './inputFieldDialogHelpers';

export const DryRunResult: React.FC<{ result: InputDryRunResult }> = ({ result }) => (
  <Box className="space-y-3">
    <Alert severity={result.ok ? 'success' : 'warning'}>{result.ok ? 'ok' : 'has issues'}</Alert>
    <TextField
      label="Built body"
      value={JSON.stringify(result.body ?? {}, null, 2)}
      multiline
      fullWidth
      rows={6}
    />
    {result.normalizationLog.length > 0 && (
      <Box className="rounded border border-slate-200 dark:border-slate-700">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Field</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>From</TableCell>
              <TableCell>To</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {result.normalizationLog.map((item, index) => (
              <TableRow key={`${item.field}-${index}`}>
                <TableCell>{item.field}</TableCell>
                <TableCell>{item.action}</TableCell>
                <TableCell>{formatValue(item.from)}</TableCell>
                <TableCell>{formatValue(item.to)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    )}
    {result.issues.length > 0 && (
      <Alert severity="error">
        {result.issues.map((issue) => (
          <div key={`${issue.field}-${issue.code}`}>
            {issue.field}: {issue.message}
          </div>
        ))}
      </Alert>
    )}
    <Typography variant="body2">
      Applied price row:{' '}
      {result.priceRow
        ? `${result.priceRow.metric}/${result.priceRow.unitType} ${formatValue(result.priceRow.condition)}`
        : 'None'}
    </Typography>
  </Box>
);
